import { useContext, useMemo } from 'react';
import { FsContext } from '../fsData/FsContext';
import { FsVariationToForceContext } from '../fsData/variationsToForceContext';
import { FsCampaign, FsCampaignData, FsVariation, Targetings } from '../type';
import { FsHitsContext } from '../fsData/fsHitsContext';
import { ToastContext } from '../Provider/Toast/ToastContext';

export function useFsContext() {
  const context = useContext(FsContext);
  return context;
}

export function useFsVisitorVariations() {
  return useFsContext().fsDataState.visitorVariations;
}

export function useFsVisitorExposedCampaign() {
  return useFsContext().fsDataState.visitorExposedCampaign;
}
export function useFsVariationsToForceContext() {
  return useContext(FsVariationToForceContext);
}

export function useFsVariationsToForce() {
  return useFsVariationsToForceContext().fsVariationToForceState.variationsToForce;
}

export function useFsEnvId() {
  return useFsContext().fsDataState.fsEnvId;
}

export function useBucketingFile() {
  return useFsContext().fsDataState.bucketingFile;
}

export function useIsFs() {
  return !!useFsContext()?.fsDataState?.fsEnvId;
}

export function useDefaultVariationId(campaignId: string) {
  const variationsToForce = useFsVariationsToForce();
  const visitorVariations = useFsVisitorVariations();
  const forcedVariation = variationsToForce[campaignId];
  const visitorVariation = visitorVariations && visitorVariations[campaignId];

  const defaultVariationId = forcedVariation?.variation?.id || visitorVariation?.variationId;
  const visitorVariationId = visitorVariation?.variationId;
  return { defaultVariationId, visitorVariationId };
}

export function useCampaignDataMemo(campaign: FsCampaign): FsCampaignData {
  const CampaignDataMemo: FsCampaignData = useMemo(() => {
    let variations: FsVariation[] = [];
    let targetingGroups: { targetings: Targetings[] }[] = [];

    campaign.variationGroups.forEach((item) => {
      variations = [
        ...variations,
        ...item.variations.map((value) => ({ ...value, variationGroupId: item.id, variationGroupName: item.name })),
      ];
      targetingGroups = [...targetingGroups, ...item.targeting.targetingGroups];
    });
    return { variations, targetingGroups };
  }, [campaign.variationGroups]);
  return CampaignDataMemo;
}

export function useFsHitsContext() {
  const context = useContext(FsHitsContext);
  return context;
}

export function useShowToast() {
  const context = useContext(ToastContext);
  return context.showToast;
}
